import SplitSection from "./SplitSection";

// Body text with a short hint / label held to one side.
export default function HintSection(props: { section: CaseStudyHintSectionT }) {
  const { title, side, hint, body } = props.section;

  return (
    <SplitSection variant="hint" title={title} side={side} aside={<p className="case-hint">{hint}</p>}>
      <p className="case-body">{body}</p>
    </SplitSection>
  );
}
